import React, { useContext } from 'react';
import DateRangeInput2 from '../FormFields/DateRangeInput2';
import NumberInput from '../FormFields/NumberInput';
import SelectInput2 from '../FormFields/SelectInput2';
import { BaseDataContext } from '../../Context/BaseDataContext';
import PrimaryButton from '../FormFields/PrimaryButton';
import { FaTimes } from 'react-icons/fa';
import { Breakpoint } from 'react-socks';

function SearchForm(props) {
  const [baseData, setBaseData] = useContext(BaseDataContext);

  const innerWrapperClass = "px-2 md:px-6 sm:py-4 border-l flex flex-1 items-center sm:flex-col sm:items-start hover:bg-cruise_darkblue-secondary";
  const labelClass = "text-cruise_gray text-xs whitespace-no-wrap mb-0 w-32";
  const inputClass = "w-full bg-cruise_darkblue text-white cursor-pointer text-center";
  let popperOffset1 = "-75px 7px";
  let popperOffset2 = "100px 30px";
  if (props.calendarPopsDown) {
    popperOffset1 = "-75px 30px";
    popperOffset2 = "100px 7px";
  }

  const durations = [
    { id: '0', label: "1-2" },
    { id: '1', label: "3-5" },
    { id: '2', label: "6-9" },
    { id: '3', label: "10-14" },
    { id: '4', label: "15+" },
  ];

  function getDuration() {
    let valid = true;
    let durationClass = "";
    let min = parseInt(props.searchForm.durationMin);
    let max = parseInt(props.searchForm.durationMax);
    let result = "";
    if (max && min) {
      if (min === max)
        result = "Exactly " + min;
      else
        result = min + " - " + max;

      if (min > max) {
        valid = false;
      }
    }
    else {
      if (min) {
        result = min + "+";
      }
      if (max) {
        result = "Max " + max;
      }
    }

    if (!result) {
      result = "ANY";
    }
    else if (valid) {
      result += " nights";
    }
    else {
      result += " is invalid";
      durationClass = "text-red-400 italic text-base";
    }
    return <span className={durationClass}>{result}</span>;
  }

  return (
    <form>
      <div className={props.wrapperClass}>
        {/*
        <SelectInput
          wrapperClass={innerWrapperClass}
          labelClass={labelClass}
          selectPickerClass={inputClass}
          id="regionId"
          name="regionId"
          label="Destination"
          onChange={props.handleChange}
          valueKey="intId"
          searchable={false}
          firstOption="ANYWHERE"
          options={baseData.regions}
          value={props.searchForm.regionIds[props.searchForm.regionIds.length - 1]}
        />
        */}
        <SelectInput2
          id="regionId"
          wrapperClass={innerWrapperClass}
          labelClass={labelClass}
          selectPickerClass={inputClass}
          label="Destination"
          valueKey="intId"
          multiselect
          firstOption="ANYWHERE"
          directionUp={props.directionUp || false}
          options={baseData.regions}
          selectedItems={props.searchForm.regionIds}
          onItemSelected={props.handleChange}
        />
        <DateRangeInput2
          id="departure"
          wrapperClass={innerWrapperClass}
          labelClass={labelClass}
          datePickerClass="w-32 bg-transparent text-white cursor-pointer"
          idMin="departureMin"
          idMax="departureMax"
          label="Departure"
          valueMin={props.searchForm.departureMin}
          valueMax={props.searchForm.departureMax}
          popperOffset1={popperOffset1}
          popperOffset2={popperOffset2}
          onChange={props.handleChange}
        />
        <SelectInput2
          id="durationMinMax"
          wrapperClass={innerWrapperClass}
          labelClass={labelClass}
          selectPickerClass={inputClass}
          label="Number of nights"
          firstOption={getDuration()}
          name="durationMinMax"
          searchable={false}
          labelKey="label"
          directionUp={props.directionUp || false}
          options={durations}
          onItemSelected={props.handleChange}
        />
        <Breakpoint lg up >
          <NumberInput
            wrapperClass={innerWrapperClass}
            labelClass={labelClass}
            numberInputClass={inputClass}
            id="priceMax"
            name="priceMax"
            label="Max price"
            step={1000}
            value={props.searchForm.priceMax || 0}
            onChange={props.handleChange}
          />
        </Breakpoint>
        {/*
        <NumberInput
          wrapperClass={innerWrapperClass}
          labelClass={labelClass}
          numberInputClass={inputClass}
          id="durationMin"
          name="durationMin"
          label="Number of nights (min)"
          value={props.searchForm.durationMin}
          onChange={props.handleChange}
        />
        
        
        */}
        <div className="flex flex-1 justify-center items-center border-l px-2">
          {props.clearAllMode
            ?
            <Breakpoint sm up >
              <div className="w-full px-6 py-3 border cursor-pointer hover:bg-cruise_darkblue-secondary"
                onClick={props.handleSubmit}>
                <div className="flex text-xs w-full text-white justify-between items-center">
                  <span className="uppercase whitespace-no-wrap pr-1">clear all</span>
                  <FaTimes />
                </div>
              </div>
            </Breakpoint>
            :
            <PrimaryButton
              onClick={props.handleSubmit}
              buttonText={props.buttonText}
            />
          }
        </div>
      </div>
    </form>
  );
}

SearchForm.defaultProps = {
  calendarPopsDown: false
};

export default SearchForm;